module.exports = __webpack_public_path__ + "static/making-progress.851ad5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/making-progress.png
// module id = 1343
// module chunks = 242809538932529